import type { Asserts } from 'yup';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { pkvSchema } from '@/features/Sparten/pkv/schema/schema';

export const inputSchema = pkvSchema;

export type InputStore = Asserts<typeof inputSchema>;

export const usePkvInputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'PkvInputStore',
);
